/**
 * Shared custom hook for computing button disabled state and title
 */

import { useEffect, useState } from "react";
import { RegtankOnboardingStatusEnum } from "@funded-here-interface/common/src/constant/enum";
import { MESSAGES } from "../constants";

interface UseButtonStateParams {
  regtankLivenessFeatureFlag: boolean | null;
  regtankOnboardingFeatureFlag: boolean | null;
  regtankOnboarding: boolean | null;
  regtankRequest: any;
  isDisabledByLiveness: boolean;
}

export const useButtonState = ({
  regtankLivenessFeatureFlag,
  regtankOnboardingFeatureFlag,
  regtankOnboarding,
  regtankRequest,
  isDisabledByLiveness,
}: UseButtonStateParams) => {
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [titleButton, setTitleButton] = useState("");

  // Determine if identity verification is required but not complete
  const needsVerification =
    regtankLivenessFeatureFlag &&
    regtankOnboardingFeatureFlag &&
    (regtankOnboarding === false ||
      (regtankOnboarding === true &&
        (regtankRequest.length === 0 ||
          regtankRequest?.[0].onboardingStatus !==
            RegtankOnboardingStatusEnum.APPROVED)));

  useEffect(() => {
    if (needsVerification) {
      setButtonDisabled(true);
      setTitleButton(MESSAGES.VERIFICATION_REQUIRED);
    } else if (isDisabledByLiveness) {
      setButtonDisabled(true);
      setTitleButton(MESSAGES.VERIFICATION_DISABLED);
    } else {
      setButtonDisabled(false);
      setTitleButton("");
    }
  }, [needsVerification, isDisabledByLiveness]);

  const disableButton = (message: string) => {
    setButtonDisabled(true);
    setTitleButton(message);
  };

  return {
    buttonDisabled,
    titleButton,
    disableButton,
  };
};
